<template>
 <div class="container" style="background:white;overflow:hidden">
      

       <div class="menutop_mobile">
         <div  @click="showprofile = !showprofile" class="circlehamburger" >
            <i style="color:white;" class="fas fa-bars"></i>
        </div>
            <div style="height: 100%; display: flex; align-items: center; position: relative; left: 20px;"> 
            <div class="fontbold2">Mentor</div> 
            </div>
        </div>

    <div class="columns">
          <div class="column is-one-quarter box-step pd-5 bgcolor" :class="{openprofile: showprofile}" >
                <div class="widthmenu" >
                    <div class="has-text-left">
                        <p class="is-size-4 title">Mentor profile</p>
                        <div class="imgprofile">
                        </div>
                        <div class="textprofile" style="margin-bottom:20px">
                            <p class="fontnormal">
                            Chaiyawat, (Ball)
                            </p>
                            <p class="fontnormal">
                            Bangkok, thailand
                            </p>
                            <p class="fontnormal">
                            +66 89 124 9875
                            </p>
                                 <nav class="level is-mobile">
                                <div class="level-left">
                                    <a class="level-item">
                                    
                                        <div class="circle">
                                        <i class="fab fa-facebook-f"></i>
                                        </div>
                                    
                                    </a>
                                    <a class="level-item">
                                    
                                        <div class="circle">
                                        <i class="fab fa-linkedin-in"></i>
                                        </div>
                                    </a>
                                    <a class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-line"></i>
                                        </div>
                                    </a>
                                </div>
                                </nav>
                        </div>
                    </div>
                </div>
                   <b-button @click="gopath('/signin')" class="buttonorange"  type="is-primary">SIGN OUT</b-button>
            </div>


            <div class="column">
                <div class="columns">
                <div class="column"></div>
                <div class="column is-four-fifths" style="margin-bottom:50px;">
                    <div class="fontnormal2"  style="font-size:30px !important;">
                       Summary
                        <div class="underline"></div>
                    </div>
                    <br>
                    <br>
                     <div class="fontnormal2">
                        <strong>Who are you?</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="containeralldetail"> 
                     <div class="fontnormal2">     
                         Who are you? 
                         <span style="padding-left: 15px;">
                          <span v-for="(val,index) in forms.input.whoAreYou" class="fontblue">{{ `${val.label} ${comma('whoAreYou',index)}`  }}</span>
                         </span>
                     </div>
                      <div class="fontnormal2">
                         Do you love to be a volunteer?
                         <span style="padding-left: 15px;">
                          <span v-for="(val,index) in forms.input.loveVolunteer" class="fontblue">{{ `${val.label} ${comma('loveVolunteer',index)}`  }}</span>
                         </span>
                     </div>
                      <div class="fontnormal2">
                         Why do you want to be a volunteer?
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-for="(val,index) in forms.input.wantVolunteer" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>
                    <div class="fontnormal2" style="margin-top: -16px;">
                         Hourly Rate
                         <span class="fontblue" style="padding-left: 15px;">
                          {{ `$${forms.input.hourlyRateAmount}/${forms.input.hourlyRate.label}`}}
                         </span>
                     </div>
                     <div class="fontnormal2">
                         Industry interested
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-for="(val,index) in forms.input.areYouInterestedInInvesting" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>
                      <div v-if="forms.input.otherinvest" class="fontnormal2" style="margin-top: -16px;">
                         Other
                         <span class="fontblue" style="padding-left: 15px;">
                          {{ `${forms.input.otherinvest}`}}
                         </span>
                     </div>

                      <div class="fontnormal2" style="margin-top: -16px;">
                         Which size of investment you are?
                          <div >
                            <div v-for="(val,index) in forms.input.whichSizeOfInvestment" class="fontblue" style="display:block;margin-top:5px">
                            {{ `${val.label}`  }}
                           </div>
                           </div>
                     </div>
                     <br>
                     <div class="fontnormal2">
                         <strong>Basic profile</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="containimg">
                      <div class="imgprofile">
                        </div>
                        
                    </div>
                    <br>
                     
                    <div class="fontnormal2">
                      <div class="columns">
                             <div class="column">Name <span class="fontblue">{{ forms.input.nameMentor }} </span></div>
                            <div class="column">Surename <span class="fontblue">{{ forms.input.surenameMentor }}</span></div>
                        </div>
                        <div class="columns">
                             <div class="column">Nickname <span class="fontblue">{{ forms.input.nicknameMentor }} </span></div>
                            <div class="column">Date of birth <span class="fontblue">{{ forms.input.dateofBirthMentor | formatDate }} </span></div>
                        </div>
                          <div class="columns">
                             <div class="column">Living in <span class="fontblue">{{ forms.input.livingInMentor.label }} </span></div>
                            <div class="column">Country <span class="fontblue">{{ forms.input.countryMentor.label }} </span></div>
                        </div>
                        <div class="columns">
                             <div class="column">Gender <span class="fontblue">{{ forms.input.genderMentor.data.label }} </span></div>
                            <div class="column">Telephone number <span class="fontblue">{{ forms.input.countryCode+''+forms.input.telephoneNumberMentor }} </span></div>
                        </div>
                        <div class="columns">
                             <div class="column">E-mail <span class="fontblue">{{ forms.input.emailMentor }} </span></div>
                        </div>
                         <div class="columns">
                             <div class="column">  Website (Optional) <span class="fontblue">{{ forms.input.websiteMentor }} </span></div>
                        </div>
                     </div>

                      <br>
                     <div class="fontnormal2">
                         <strong>Introduction</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                     <div class="fontnormal2">     
                         About me (Limited to 300 characters)
                         <div>
                         <div class="fontblue" style="padding:0;margin:10px 0 0 0;min-height: 91px;">
                            {{ forms.input.anoutMe  }} 
                         </div>
                         </div>
                     </div>
                      <div class="fontnormal2">     
                         Profession title
                         <div>
                         <div class="fontblue" style="padding:0;margin:10px 0 0 0">
                            {{ forms.input.professionTitle  }} 
                         </div>
                         </div>
                     </div>
                     
                     <div class="fontnormal2">
                         Industry Expertise
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-for="(val,index) in forms.input.industryexpertise" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>
                    
                     <div v-if="forms.input.otherintro" class="fontnormal2">     
                         Other
                         <div>
                         <div class="fontblue" style="padding:0;margin:10px 0 0 0">
                            {{ forms.input.otherintro  }} 
                         </div>
                         </div>
                     </div>

                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0" >  
                        Social profiles
                     </div>
                    <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Facebook 
                         <span style="padding-left: 15px;">
                             <span class="fontblue"> {{ forms.input.facebookMentor  }} </span> 
                         </span>
                     </div>
                       <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Linkedin 
                         <span style="padding-left: 15px;">
                             <span class="fontblue"> {{ forms.input.linkedinMentor  }} </span> 
                         </span>
                     </div>
                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Line 
                         <span style="padding-left: 15px;">
                             <span class="fontblue"> {{ forms.input.lineMentor  }} </span> 
                         </span>
                     </div>
                      <br>
                     <div class="fontnormal2">
                        <strong>Language</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                     <div class="fontnormal2">     
                         Talk well in
                         <span style="padding-left: 15px;">
                          <span v-for="(val,index) in forms.input.talkWellInMentor" class="fontblue">{{ `${val.label} ${comma('talkWellInMentor',index)}`  }}</span>
                         </span>
                     </div>
                    </div>
                    <!-- <b-button @click="submitmentor" class="buttonorange" style="margin:25px 0 0 0;"  type="is-primary">CONFIRM</b-button> -->
                 </div>
                <div class="column"></div>
                </div>

            </div>
    </div>
 </div>
</template>

<script>
import { mapState } from "vuex";
import {HTTP,HTTPDynamic} from "@/axios.js";

export default{
    data() {
        return {
            forms:[],
            showprofile:false
        }
    },
    computed: {
         ...mapState(["beforedataform","token","formId"]),
    },
    methods:{
        comma(name,index){
           if(this.forms.input[name].length > 1){
               if(this.forms.input[name].length != index+1){
                   return `,`
               }else{
                    return ''
               }
           }
           return ''
        },
         gopath(val){
              this.$router.push(val)
          },
    },
    created(){
      this.forms = this.beforedataform
       console.log('this.forms',JSON.stringify(this.forms))
      console.log('this.forms',this.forms)
    }
}
</script>
<style scoped>

.menutop_mobile .fontbold2{
    display: none
}
.fontnormal2 .column{
    padding: 0;
    /* margin:0; */
}
.fontnormal2 .columns{
        margin: 0 0 10px 0;
}
.center .columns{
    text-align: left
}
.containimg{
    height: 100%;
    display: flex;
    justify-content: center;
}
.blueoutline:hover,.blueoutline:focus,.blueoutline{
   border-radius: 21px !important;
    border-color: #0D6ACA !important;
    color: #0D6ACA !important;
    background: white !important;
    margin-top: 10px;
}
.fontblue .blueoutline:nth-child(n+1){
    margin-left: 10px;
}
.containeralldetail .fontnormal2:nth-child(n+1){
margin-top: 5px;
}
.underline{
  position: absolute;
  bottom: -15px;
  width: 100%;
  background: #F3F3F3;
  height: 1px;
}

.fontnormal2{
    position: relative;
    color: #000000 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.fontnormal2 .fontblue{
     position: relative;
    color: #0D6ACA !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
    margin-left: 5px;
    
}
.edit{
    cursor: pointer;
    float:right
}
.edit i{
color:#C4C4C4
}
.edit .fontnormal2{
    position: relative;
    color:#C4C4C4 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.buttonorange{
     padding: 5px 2rem;
    font-weight: 600;
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
    margin: 0 auto;
    display: block;
}
.level.is-mobile{
    margin-top: 10px;
}
.level-item{
    margin-right: 0.55rem;
}
i{
  color: #0d6aca;
  justify-content: center;
  
}
.circle{
        border-radius: 50%;
    background: white;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 28px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
}

.fontnormal{
  font-family: 'Raleway';
font-size: 14px;
color: #FFFFFF;
}

.bgcolor{
    overflow: hidden !important;
    border-color: white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
    min-height: 100vh;
}
.fontbold{
 font-family: 'Raleway';
  font-weight: bold;
font-size: 14px;
color: white;
}
.textprofile{
    float: left;
    width: calc( 100% - 140px);
    min-height: 140px;
    padding: 20px 10px 10px 20px;
}
.title{
        color: white;
    padding-left: 11px;
    font-weight: bold;
     margin-bottom: 1.5rem;
}
.imgprofile{
    float: left;
    /* background: #89C3FE; */
    background: url("../assets/Intersect.png");
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    width: 140px;
    height: 140px;
    border-radius: 70px;
}

.bgcolor{
    overflow:hidden !important;border-color:white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
    min-height: 100vh;
}
.buttonc{
        padding-left: 2rem;
    padding-right: 2rem;
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}

/* menu */
.circlehamburger{
    display: none;
    height: 50px;
    width: 50px;
    position: fixed;
    background: #0d6aca;
    color: white;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    transition: all 0.5s;
    z-index: 100;
}
.widthmenu{
width:90%;float:right;
}

.column.is-four-fifths{
        margin-top: 10px;
    }
@media only screen and (max-width: 951px) {
    .column.is-four-fifths{
        margin-top: 75px;
    padding: 22px;
    }
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
    min-height: 200px;
    min-width: 390px;
    position: absolute;
    right: 2px;
    z-index: 88;
    border-radius: 20px;
    transform: scaleX(0);
      top: -300px;
    transition: all 0.5s;
    opacity: 0;
}
       .menutop_mobile .fontbold2{
    display: block
	}
 .circlehamburger{
    display: flex;
}
.menutop_mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
    background: #0d6aca;
    z-index: 99;
    transition: all 0.5s;
}

.openprofile{
    top: 70px !important;
    opacity: 1 !important;
    transform: scaleX(1)!important;
}
}



@media only screen and (max-width: 400px) {
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
       width: 355px;
           min-width: 366px;
    }
    .widthmenu{
    width: 100%;
    }
}
/* menu */

@media only screen and (max-width: 371px) {
div.column.is-one-quarter.box-step.pd-5.bgcolor{
  width: 250px;
    min-width: 324px;
}
}
</style>
